import Vue from "vue";
import Router from "vue-router";
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";

import Home from "../views/Home";
import HomeM from "../views/mobile/Home";
import SketchScope from "../views/SketchScope";
import SketchScopeM from "../views/mobile/SketchScope";
import MotionRecognition from "../views/MotionRecognition";
import MotionRecognitionM from "../views/mobile/MotionRecognition";
import AR from "../views/AR";
import ARM from "../views/mobile/AR";
import Others from "../views/Others";
import OthersM from "../views/mobile/Others";
import Ammonite from "../views/Ammonite";
import AmmoniteM from "../views/mobile/Ammonite";

Vue.use(Router, VueVideoPlayer);

const compMap = {
  home: [Home, HomeM],
  ss: [SketchScope, SketchScopeM],
  mr: [MotionRecognition, MotionRecognitionM],
  ar: [AR, ARM],
  etc: [Others, OthersM],
  ammonite: [Ammonite, AmmoniteM],
};

function getComponents(mode) {
  const [d, mobile] = compMap[mode];
  return {
    default: d,
    mobile,
  };
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      components: getComponents(process.env.VUE_APP_ROUTER_COMP || "home"),
    },
  ],
});
